<template>
  <div class="trade-offline-detail-page" :class = "{'clear-header':isWechatBrowser}">
    <my-header v-if="!isWechatBrowser" title="退订金申请" :showBack="true"></my-header>
    <div v-if="tradeOffline.deposit" class="offline-top-bg">
      <div class="title">
        实际退款金额&nbsp;&nbsp;&nbsp;¥{{tradeOffline.deposit}}元
      </div>
    </div>
    <div class="info general-box-shadow">
      <div class="trade-offline-info" style="border: none">
        <div class="input-group border-top-style">
          <div class="input-label">退款原因</div>
          <input class="mint-field-core form-input" type="text" v-model="reason" placeholder="请输入退款原因">
        </div>
        <div class="offline-info-item">
          <div class="info-field-name">订单类型:</div>
          <div>
            <span v-if="tradeOffline.type == '1'">全款订单</span>
            <span v-if="tradeOffline.type == '2'">团购订单</span>
            <span v-if="tradeOffline.type == '3'">普通订单</span>
          </div>
        </div>
        <div class="offline-info-item">
          <div class="info-field-name">订单状态:</div><div>{{offlineStatusMap[tradeOffline.status]}}</div>
        </div>
        <div class="offline-info-item">
          <div class="info-field-name">订单编号:</div><div>{{tradeOffline.orderNo}}</div>
        </div>
        <div class="offline-info-item">
          <div class="info-field-name">下单时间:</div><div>{{tradeOffline.createTime | longTime}}</div>
        </div>
        <div class="offline-info-item">
          <span class="info-field-name">订金金额:</span><span>¥{{tradeOffline.deposit}}</span>
        </div>
        <div class="offline-info-item">
          <span class="info-field-name">补贴优惠:</span><span>¥{{activity.discount}}</span>
        </div>
      </div>
    </div>
    <div class="form-btn" @click="offlineRefund" >提交</div>
  </div>
</template>

<script>
  import {Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import tradeOfflineService from '../../service/trade/TradeOfflineService'

  export default {
    name: 'OfflineRefund',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        tradeOfflineId:'',
        tradeOffline:{},
        activity:{discount:0},
        offlineStatusMap:[],
        reason:'',
        isWechatBrowser:this.$verfyBrowserType()
      }
    },
    created(){
      this.tradeOfflineId = this.$route.query.tradeOfflineId;
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      this.getTradeOfflineDetail();
    },
    methods: {
      async getTradeOfflineDetail(){
        let {code,msg,data} = await tradeOfflineService.detail(this.tradeOfflineId);
        if(code == '0'){
          this.activity = data.activity || this.activity;
          this.tradeOffline = data.offline;
          this.offlineStatusMap = data.offlineStatusMap;
        }else {
          Toast(msg);
        }
      },
      async offlineRefund(){
        let {code,msg,data} = await tradeOfflineService.refundOffline(this.tradeOfflineId,this.reason);
        if(code == '0'){
          Toast('申请退订金成功!');
          this.$router.go(-1);
        }else {
          Toast(msg);
        }
      }
    }
  }
</script>
<style lang="scss">
  @import '../../assets/style/common.scss';
  .trade-offline-detail-page {
    height: 100vh;
    background: white;
    font-size: 0.32rem;
    .offline-top-bg{
      height: 1.06rem;
      background-image: url(../../assets/appointment/icon-top-bg.png);
      .title{
        padding-top: 0.28rem;
        padding-left: 0.3rem;
        font-size: 0.36rem;
      }
    }
    .info{
      width: 6.90rem;
      margin: 0.3rem 0.2rem 0 0.3rem;
      .input-group{
        height: 0.96rem;
        display: block;
        padding-bottom: 0.1rem;
        border-bottom: 1px solid #e0dedc;
        .input-label{
          width: auto;
          margin-top: 0.3rem;
          font-size: 0.28rem;
          font-weight: normal;
          font-stretch: normal;
          color: #7f7d7c;
        }
        .form-input{
          width: 6.9rem;
          height: 0.5rem;
          margin: 0 auto;
          line-height: 0.69rem;
          font-size: 0.32rem;
          background-color: white;
        }
      }
    }
    .offline-btn-group{
      display: flex;
      justify-content: flex-end;
      margin-top: 0.42rem;
      margin-right: 0.6rem;
    }
    .general-btn{
      margin-left: 0.2rem;
    }
  }
</style>
